// panels/PiePanel.jsx
import React from 'react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { PanelWrapper } from './PanelWrapper';

const SEVERITY_COLORS = {
  CRITICAL: '#ef4444',
  WARNING:  '#f59e0b',
  INFO:     '#3b82f6',
};

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const { name, value } = payload[0];
  return (
    <div style={{
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 8, padding: '8px 12px', fontSize: 11,
    }}>
      <span style={{ color: SEVERITY_COLORS[name] || '#64748b', fontWeight: 600 }}>{name}</span>
      <span style={{ color: 'var(--text-2)', marginLeft: 8 }}>{value} alerts</span>
    </div>
  );
}

function CenterLabel({ cx, cy, total }) {
  return (
    <g>
      <text x={cx} y={cy - 6} textAnchor="middle" fill="#e2e8f0" fontSize={22} fontWeight={700}
        fontFamily="'Space Mono', monospace">{total}</text>
      <text x={cx} y={cy + 12} textAnchor="middle" fill="#64748b" fontSize={10}>active</text>
    </g>
  );
}

export function PiePanel({ data = [], loading, title = 'Alert Severity' }) {
  const chartData = data
    .map(d => ({ name: d._id || d.name, value: d.count || d.value || 0 }))
    .filter(d => d.value > 0);

  const total = chartData.reduce((s, d) => s + d.value, 0);

  if (!chartData.length) {
    return (
      <PanelWrapper title={title} datasource="MongoDB" loading={loading}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200, color: 'var(--text-3)', fontSize: 12 }}>
          No active alerts
        </div>
      </PanelWrapper>
    );
  }

  return (
    <PanelWrapper title={title} datasource="MongoDB" loading={loading}>
      <div style={{ padding: '8px 0', height: 200 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={52}
              outerRadius={75}
              paddingAngle={3}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
            >
              {chartData.map((d, i) => (
                <Cell key={i} fill={SEVERITY_COLORS[d.name] || '#64748b'} stroke="none" />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend
              iconType="circle"
              iconSize={8}
              wrapperStyle={{ fontSize: 11 }}
              formatter={val => <span style={{ color: 'var(--text-2)' }}>{val}</span>}
            />
            {/* Center label rendered via customized label */}
            <text x="50%" y="43%" textAnchor="middle" dominantBaseline="central"
              fill="#e2e8f0" fontSize={22} fontWeight={700} fontFamily="'Space Mono', monospace">
              {total}
            </text>
            <text x="50%" y="53%" textAnchor="middle" dominantBaseline="central"
              fill="#64748b" fontSize={10}>
              active
            </text>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </PanelWrapper>
  );
}
